import { Edit } from 'react-admin';
import { OrderForm } from './Order.Form';

export const OrderEdit = () => {
    return (
        <Edit>
            <OrderForm />
        </Edit>
    );
};
